<template>
  <section class="w-full flex flex-row justify-center bg-themeComponentBg-light font-rubik cover-outer-container">
    <div class="w-full max-w-1440 mx-5 cover-inner-container flex flex-col 1240-bp:flex-row">
      <!-- Header Section -->
      <header class="w-full flex flex-col">
        <div class="h-full flex flex-col items-start justify-end py-3">
          <h2 class="header-two hidden 1240-bp:inline-block">The largest network of shipping and storage <br> Container Providers in <br> North America.</h2>
          <h2 class="header-two 1240-bp:hidden">The largest network of shipping and storage container providers in North America.</h2>
        </div>
      </header>
      <!-- Content Section -->
      <article class="w-full flex flex-col items-start 1240-bp:items-end justify-end">
        <div class="flex flex-col items-start justify-end pb-2">
          <p class="cover-p hidden 1240-bp:inline-block">With providers nationwide, Container Alliance offers an</p>
          <p class="cover-p hidden 1240-bp:inline-block">extensive amount of knowledge to help you find the best</p>
          <p class="cover-p hidden 1240-bp:inline-block">container solution — with prices you won't find anywhere else.</p>
          <p class="cover-p 1240-bp:hidden">With providers nationwide, Container Alliance offers an extensive amount of knowledge to help you find the best container solution — with prices you won't find anywhere else.</p>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
//improve search engine optimization
export default {
  name: 'ShippingContainerComponent',
  mounted() {
    try {
      const meta = document.createElement('meta')
      meta.name = 'description'
      meta.content = 'Container Alliance provides the largest network of shipping & storage container providers in North America, with flexible options and expert support.'
      document.head.appendChild(meta)
    } catch (e) {
      console.warn('Failed to inject meta description:', e)
    }
    try {
      const ld = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': document.title || 'Container Alliance',
        'url': window.location.href,
        'publisher': {
          '@type': 'Organization',
          'name': 'Container Alliance'
        }
      }
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.text = JSON.stringify(ld)
      document.head.appendChild(script)
    } catch (e) {
      console.warn('Failed to inject JSON-LD:', e)
    }
  }
}
</script>

<style scoped>
.cover-outer-container {
  padding-top: 48px
}

.cover-inner-container {
  height: auto;
}

.header-one {
  display: inline-block;
  padding: 8px 12px;

  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: -0.0125em;
  color: black;

  background-color: #EEECE9;
  border: 1px transparent;
  border-radius: 8px;
}

.header-two {
  font-size: 56px;
  font-weight: 400;
  line-height: 67.2px;
  letter-spacing: -0.04em;
  line-height: 1.1;
  color: black;
}

.cover-p {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  color: black;
}

/* Mobile */
@media (max-width: 1240px) {
  .cover-outer-container {
    padding-top: 24px
  }

  .header-one {
    font-size: 14px;
  }
  .header-two {
    font-size: 38px;
  }
  p {
    font-size: 16px;
  }
}
</style>
